import { $, $$, store, isMobile } from './env';

/*
 * Nhạc nền: <audio data-bgm src="..."> đặt trong HTML (khách đổi link ở đó, để trống src = ẩn nút).
 * Trình duyệt chặn tự phát có tiếng → nếu người dùng đang để "mở", nhạc bắt đầu ở thao tác đầu tiên.
 */
const KEY = 'nth-sound';
const root = document.documentElement;
let audio;
let fadeTimer;

const wanted = () => store.get(KEY, 'on') === 'on';

function render(on) {
  root.setAttribute('data-sound', on ? 'on' : 'off');
  $$('[data-sound-toggle]').forEach((btn) => btn.setAttribute('aria-pressed', String(on)));
}

function fadeTo(target, done) {
  clearInterval(fadeTimer);
  fadeTimer = setInterval(() => {
    const v = audio.volume + (target > audio.volume ? 0.05 : -0.05);
    audio.volume = Math.min(1, Math.max(0, v));
    if (Math.abs(audio.volume - target) < 0.051) {
      audio.volume = target;
      clearInterval(fadeTimer);
      if (done) done();
    }
  }, 40);
}

function play() {
  if (!audio) return;
  audio.volume = 0;
  const p = audio.play();
  if (p && p.then) p.then(() => fadeTo(0.6)).catch(() => {});
}

function pause() {
  if (!audio || audio.paused) return;
  fadeTo(0, () => audio.pause());
}

export function initAudio() {
  audio = $('audio[data-bgm]');
  const src = audio && (audio.getAttribute('src') || '').trim();
  // PSD mobile không có nút âm thanh → không phát nhạc trên điện thoại (không có chỗ tắt)
  if (!audio || !src || isMobile()) {
    root.classList.add('no-bgm');
    return;
  }
  render(wanted());

  $$('[data-sound-toggle]').forEach((btn) => btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const on = !wanted();
    store.set(KEY, on ? 'on' : 'off');
    render(on);
    if (on) play(); else pause();
  }));

  // thao tác đầu tiên của người dùng = được phép phát tiếng
  const unlock = () => {
    if (wanted() && audio.paused) play();
  };
  ['pointerdown', 'keydown', 'touchstart'].forEach((ev) => document.addEventListener(ev, unlock, { once: true, passive: true }));

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) pause();
    else if (wanted() && !root.classList.contains('has-video')) play();
  });
  // đang xem video môn phái thì tạm dừng nhạc nền
  document.addEventListener('nth:video', (e) => {
    if (e.detail.open) pause();
    else if (wanted()) play();
  });
}
